import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading, checked, refresh } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (!checked) refresh();
  }, [checked, refresh]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="protected-loading">
        <div className="font-mono text-xs uppercase tracking-[0.3em] text-ink-500">Authenticating…</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return children;
}
